/**
 * i18n del REDISEÑO de Costos y Ganancias (feature src/features/costs).
 * Se mergea en translations.js igual que comandas.js. Claves planas con puntos.
 */
const costs = {
  es: {
    // común
    "costs.common.loading": "Cargando…",
    "costs.common.back": "Volver",
    "costs.common.backAria": "Volver",
    "costs.common.cancel": "Cancelar",
    "costs.common.save": "Guardar",
    "costs.common.saving": "Guardando…",
    "costs.common.saved": "✓ Guardado",
    "costs.common.unsaved": "Tenés cambios sin guardar",
    // nav
    "costs.nav.brand": "Costos y ganancias",
    "costs.nav.backAria": "Volver al panel",
    "costs.nav.platos": "Mis platos",
    "costs.nav.ingredientes": "Ingredientes",
    "costs.nav.ajustesAria": "Ajustes",
    // status
    "costs.status.ok": "Buena ganancia",
    "costs.status.warn": "Ganancia justa",
    "costs.status.bad": "Poca ganancia",
    "costs.status.loss": "Estás perdiendo",
    "costs.status.unknown": "Sin costo",
    // frases plata
    "costs.keep.pos": "te quedan {m}",
    "costs.keep.neg": "perdés {m}",
    "costs.line.costs": "te cuesta",
    "costs.line.sells": "la vendés a",
    "costs.line.sellsIt": "lo vendés a",
    "costs.confirm.discard": "Tenés cambios sin guardar. ¿Salir y descartarlos?",
    "costs.line.direct": "Ingredientes",
    "costs.line.indirect": "otros gastos ({n}%)",
    "costs.common.saveError": "Error al guardar",
    "costs.priceN": "Precio {n}",
    // mis platos
    "costs.platos.eyebrow": "Tus números",
    "costs.platos.title": "Mis platos",
    "costs.platos.sub": "Lo que te cuesta cada plato y lo que te queda al venderlo.",
    "costs.platos.avgLbl": "De cada plato te quedan, en promedio",
    "costs.platos.perDish": "por plato",
    "costs.platos.progress": "Costeaste {done} de {total} platos. Cargá los que faltan para ver el panorama completo.",
    "costs.platos.startLbl": "Empecemos",
    "costs.platos.startBig": "Costeá tu primer plato",
    "costs.platos.startCap": "Elegí un plato de la lista y cargá lo que lleva. En un minuto vas a saber cuánta plata te deja.",
    "costs.platos.best": "El que más te deja",
    "costs.platos.watch": "Ojo con este",
    "costs.platos.grpRevisar": "Para revisar",
    "costs.platos.grpBien": "Van bien",
    "costs.platos.grpSin": "Sin costear",
    "costs.platos.fix": "↑ Cobrándola {price} te quedarían {keep}",
    "costs.platos.noPrice": "Este plato no tiene precio en tu carta — cargalo para ver cuánto te queda",
    "costs.platos.todo": "Cargá lo que lleva este plato para ver cuánto ganás",
    "costs.platos.costear": "Costear",
    // costear
    "costs.costear.sellsAt": "la vendés a {m}",
    "costs.recipe.title": "¿Qué lleva este plato?",
    "costs.recipe.desc": "Escribí un ingrediente; si no existe, lo creás al toque.",
    "costs.costear.escapeQ": "¿No sabés el detalle?",
    "costs.costear.escapeLink": "Poné un costo aproximado y listo →",
    "costs.quick.title": "Costo aproximado",
    "costs.quick.desc": "Poné más o menos cuánto te sale hacer este plato.",
    "costs.quick.label": "Me sale, más o menos…",
    "costs.quick.backQ": "¿Preferís cargar los ingredientes?",
    "costs.quick.backLink": "Detallar la receta →",
    "costs.adv.title": "Ajustes avanzados",
    "costs.adv.indirect": "A todos los platos les sumamos un {n}% por otros gastos (luz, gas). Lo cambiás en Ajustes.",
    "costs.adv.remove": "Quitar el costo de este plato",
    "costs.panel.keep": "Con esto, te quedan",
    "costs.panel.lose": "Con esto, perdés",
    "costs.panel.noCost": "Todavía sin costo",
    "costs.panel.keepPct": "De cada plato, te quedás con {n}%.",
    "costs.panel.ok": "Vas bien 👍 Buen margen en este plato.",
    "costs.panel.suggest": "Para dejar el {n}% de ganancia, deberías cobrarlo {price}.",
    "costs.panel.hint": "Cargá lo que lleva el plato y acá vas a ver, en vivo, cuánta plata te deja.",
    // recipe builder
    "costs.recipe.search": "Escribí para buscar o crear un ingrediente…",
    "costs.recipe.prepTag": "preparado",
    "costs.recipe.createPre": "Crear",
    "costs.recipe.createPost": "nuevo",
    "costs.recipe.prepOwn": "preparado propio",
    "costs.recipe.empty": "Todavía no cargaste ingredientes. Buscá arriba el primero.",
    // crear ingrediente
    "costs.create.title": "Nuevo ingrediente",
    "costs.create.what": "¿Qué comprás?",
    "costs.create.price": "¿Cuánto te sale?",
    "costs.create.how": "¿Cómo lo comprás?",
    "costs.create.add": "Agregar ingrediente",
    // unidades de compra
    "costs.buy.kg": "Por kilo",
    "costs.buy.u": "Por unidad",
    "costs.buy.lt": "Por litro",
    "costs.buy.doc": "Por docena",
    // traducción de compra
    "costs.buyTr.gram": "Te sale {m} el gramo.",
    "costs.buyTr.ml": "Te sale {m} el ml.",
    "costs.buyTr.each": "Te sale {m} cada uno.",
    "costs.buyTr.zero": "Poné cuánto te sale para calcular el costo.",
    // por-unidad
    "costs.per.kg": "el kilo",
    "costs.per.g": "el gramo",
    "costs.per.lt": "el litro",
    "costs.per.ml": "el ml",
    "costs.per.doc": "la docena",
    "costs.per.u": "cada uno",
    // ingredientes
    "costs.ing.eyebrow": "Lo que comprás",
    "costs.ing.title": "Ingredientes",
    "costs.ing.sub": "Cargás el precio una vez y sirve para todos los platos que lo usan.",
    "costs.ing.addTitle": "Agregar un ingrediente",
    "costs.ing.addDesc": "Empezá a escribir y te sugerimos los típicos.",
    "costs.ing.namePh": "Ej: Muzzarella",
    "costs.ing.presetKg": "por kilo",
    "costs.ing.presetU": "por unidad",
    "costs.ing.presetLt": "por litro",
    "costs.ing.empty": "Todavía no cargaste ingredientes. Agregá el primero arriba.",
    "costs.ing.unused": "Sin usar todavía",
    "costs.ing.usedIn": "Usado en",
    "costs.ing.and": "y",
    "costs.ing.platoSing": "plato",
    "costs.ing.platoPlur": "platos",
    "costs.ing.prepSing": "preparado",
    "costs.ing.prepPlur": "preparados",
    "costs.ing.updated": "actualizado {ago}",
    // tiempo
    "costs.ago.today": "hoy",
    "costs.ago.yesterday": "ayer",
    "costs.ago.days": "hace {n} días",
    "costs.ago.month": "hace 1 mes",
    "costs.ago.months": "hace {n} meses",
    // confirmaciones
    "costs.confirm.remove": "¿Quitar el costo cargado de \"{name}\"? El plato sigue en tu carta, solo se borra su ficha de costo.",
    "costs.confirm.delUsed": "\"{name}\" se usa en {n} {recetas} ({list}). Si lo borrás, se saca de esas recetas. ¿Seguir?",
    "costs.confirm.recetaSing": "receta",
    "costs.confirm.recetaPlur": "recetas",
    "costs.confirm.del": "¿Borrar \"{name}\"?",
    "costs.confirm.delPrep": "\"{name}\" se usa en {n} {platos}. Si lo borrás, se saca de esas recetas. ¿Seguir?",
    "costs.confirm.delPrepSimple": "¿Borrar el preparado \"{name}\"?",
    // preparados
    "costs.prep.eyebrow": "Lo que preparás",
    "costs.prep.title": "Preparados",
    "costs.prep.sub": "Salsas, masas o rellenos que hacés una vez y usás en varios platos.",
    "costs.prep.new": "+ Nuevo preparado",
    "costs.prep.empty": "Todavía no tenés preparados. Creá el primero (ej: salsa de tomate).",
    "costs.prep.yields": "Rinde",
    "costs.prep.unitU": "porciones",
    "costs.prep.unitLt": "litros",
    "costs.prep.unitKg": "kilos",
    "costs.prep.perU": "la porción",
    "costs.prep.perLt": "el litro",
    "costs.prep.perKg": "el kilo",
    "costs.prep.editNew": "Nuevo preparado",
    "costs.prep.editX": "Editar {name}",
    "costs.prep.editDesc": "Cargá lo que lleva y cuánto te rinde.",
    "costs.prep.name": "¿Cómo se llama?",
    "costs.prep.namePh": "Ej: Salsa de tomate",
    "costs.prep.yield": "¿Cuánto te rinde?",
    "costs.prep.cost": "Te sale {total} en total → {perUnit} {per}.",
    "costs.prep.save": "Guardar preparado",
    // ajustes
    "costs.ajustes.eyebrow": "Cómo calculamos",
    "costs.ajustes.title": "Ajustes",
    "costs.ajustes.sub": "Dos números que definen cómo te avisamos si un plato conviene o no.",
    "costs.ajustes.currency": "Tu carta está en {menu} y los costos en {costs}. Revisá que los precios estén en la misma moneda.",
    "costs.ajustes.marginTitle": "¿Cuánta ganancia querés dejar?",
    "costs.ajustes.marginDesc": "Si un plato deja menos que esto, te lo marcamos.",
    "costs.ajustes.marginLabel": "De cada plato quiero quedarme con al menos",
    "costs.ajustes.marginHint": "Un plato que te deja menos del {n}% aparece en amarillo o rojo, con la sugerencia de precio.",
    "costs.ajustes.indirectTitle": "Otros gastos (luz, gas, sueldos)",
    "costs.ajustes.indirectDesc": "Además de los ingredientes, a cada plato le sumamos un poco por los gastos del local.",
    "costs.ajustes.indirectPre": "Sumar un",
    "costs.ajustes.indirectPost": "por otros gastos",
    "costs.ajustes.indirectHint": "Ejemplo: en un plato con {a} de ingredientes, le sumamos {b}. Si no querés sumar nada, poné 0.",
    "costs.ajustes.save": "Guardar ajustes",
  },
  en: {
    "costs.common.loading": "Loading…",
    "costs.common.back": "Back",
    "costs.common.backAria": "Back",
    "costs.common.cancel": "Cancel",
    "costs.common.save": "Save",
    "costs.common.saving": "Saving…",
    "costs.common.saved": "✓ Saved",
    "costs.common.unsaved": "You have unsaved changes",
    "costs.nav.brand": "Costs & profit",
    "costs.nav.backAria": "Back to panel",
    "costs.nav.platos": "My dishes",
    "costs.nav.ingredientes": "Ingredients",
    "costs.nav.ajustesAria": "Settings",
    "costs.status.ok": "Good profit",
    "costs.status.warn": "Tight profit",
    "costs.status.bad": "Low profit",
    "costs.status.loss": "You're losing money",
    "costs.status.unknown": "No cost yet",
    "costs.keep.pos": "you keep {m}",
    "costs.keep.neg": "you lose {m}",
    "costs.line.costs": "costs you",
    "costs.line.sells": "you sell it at",
    "costs.line.sellsIt": "you sell it at",
    "costs.confirm.discard": "You have unsaved changes. Leave and discard them?",
    "costs.line.direct": "Ingredients",
    "costs.line.indirect": "other costs ({n}%)",
    "costs.common.saveError": "Error saving",
    "costs.priceN": "Price {n}",
    "costs.platos.eyebrow": "Your numbers",
    "costs.platos.title": "My dishes",
    "costs.platos.sub": "What each dish costs you and what you keep when you sell it.",
    "costs.platos.avgLbl": "On average, each dish leaves you",
    "costs.platos.perDish": "per dish",
    "costs.platos.progress": "You've costed {done} of {total} dishes. Add the rest to see the full picture.",
    "costs.platos.startLbl": "Let's start",
    "costs.platos.startBig": "Cost your first dish",
    "costs.platos.startCap": "Pick a dish from the list and add what goes in it. In a minute you'll know how much it leaves you.",
    "costs.platos.best": "Leaves you the most",
    "costs.platos.watch": "Watch out for this one",
    "costs.platos.grpRevisar": "To review",
    "costs.platos.grpBien": "Doing well",
    "costs.platos.grpSin": "Not costed yet",
    "costs.platos.fix": "↑ Charge {price} and you'd keep {keep}",
    "costs.platos.noPrice": "This dish has no price in your menu — add it to see what you keep",
    "costs.platos.todo": "Add what goes in this dish to see how much you make",
    "costs.platos.costear": "Cost it",
    "costs.costear.sellsAt": "you sell it at {m}",
    "costs.recipe.title": "What's in this dish?",
    "costs.recipe.desc": "Type an ingredient; if it doesn't exist, create it on the spot.",
    "costs.costear.escapeQ": "Don't know the details?",
    "costs.costear.escapeLink": "Enter a rough cost and done →",
    "costs.quick.title": "Rough cost",
    "costs.quick.desc": "Enter roughly how much this dish costs you to make.",
    "costs.quick.label": "It costs me, roughly…",
    "costs.quick.backQ": "Prefer to add the ingredients?",
    "costs.quick.backLink": "Detail the recipe →",
    "costs.adv.title": "Advanced settings",
    "costs.adv.indirect": "We add {n}% to every dish for other costs (electricity, gas). Change it in Settings.",
    "costs.adv.remove": "Remove this dish's cost",
    "costs.panel.keep": "With this, you keep",
    "costs.panel.lose": "With this, you lose",
    "costs.panel.noCost": "No cost yet",
    "costs.panel.keepPct": "You keep {n}% of each dish.",
    "costs.panel.ok": "You're good 👍 Nice margin on this dish.",
    "costs.panel.suggest": "To keep {n}% profit, you should charge {price}.",
    "costs.panel.hint": "Add what goes in the dish and you'll see, live, how much it leaves you.",
    "costs.recipe.search": "Type to search or create an ingredient…",
    "costs.recipe.prepTag": "prep",
    "costs.recipe.createPre": "Create",
    "costs.recipe.createPost": "new",
    "costs.recipe.prepOwn": "own prep",
    "costs.recipe.empty": "You haven't added ingredients yet. Search for the first one above.",
    "costs.create.title": "New ingredient",
    "costs.create.what": "What do you buy?",
    "costs.create.price": "How much does it cost you?",
    "costs.create.how": "How do you buy it?",
    "costs.create.add": "Add ingredient",
    "costs.buy.kg": "By kilo",
    "costs.buy.u": "By unit",
    "costs.buy.lt": "By liter",
    "costs.buy.doc": "By dozen",
    "costs.buyTr.gram": "That's {m} per gram.",
    "costs.buyTr.ml": "That's {m} per ml.",
    "costs.buyTr.each": "That's {m} each.",
    "costs.buyTr.zero": "Enter the price to calculate the cost.",
    "costs.per.kg": "per kilo",
    "costs.per.g": "per gram",
    "costs.per.lt": "per liter",
    "costs.per.ml": "per ml",
    "costs.per.doc": "per dozen",
    "costs.per.u": "each",
    "costs.ing.eyebrow": "What you buy",
    "costs.ing.title": "Ingredients",
    "costs.ing.sub": "Set the price once and it works for every dish that uses it.",
    "costs.ing.addTitle": "Add an ingredient",
    "costs.ing.addDesc": "Start typing and we'll suggest common ones.",
    "costs.ing.namePh": "e.g. Mozzarella",
    "costs.ing.presetKg": "by kilo",
    "costs.ing.presetU": "by unit",
    "costs.ing.presetLt": "by liter",
    "costs.ing.empty": "You haven't added ingredients yet. Add the first one above.",
    "costs.ing.unused": "Not used yet",
    "costs.ing.usedIn": "Used in",
    "costs.ing.and": "and",
    "costs.ing.platoSing": "dish",
    "costs.ing.platoPlur": "dishes",
    "costs.ing.prepSing": "prep",
    "costs.ing.prepPlur": "preps",
    "costs.ing.updated": "updated {ago}",
    "costs.ago.today": "today",
    "costs.ago.yesterday": "yesterday",
    "costs.ago.days": "{n} days ago",
    "costs.ago.month": "1 month ago",
    "costs.ago.months": "{n} months ago",
    "costs.confirm.remove": "Remove the cost of \"{name}\"? The dish stays in your menu, only its cost sheet is deleted.",
    "costs.confirm.delUsed": "\"{name}\" is used in {n} {recetas} ({list}). If you delete it, it's removed from those recipes. Continue?",
    "costs.confirm.recetaSing": "recipe",
    "costs.confirm.recetaPlur": "recipes",
    "costs.confirm.del": "Delete \"{name}\"?",
    "costs.confirm.delPrep": "\"{name}\" is used in {n} {platos}. If you delete it, it's removed from those recipes. Continue?",
    "costs.confirm.delPrepSimple": "Delete the prep \"{name}\"?",
    "costs.prep.eyebrow": "What you prep",
    "costs.prep.title": "Preps",
    "costs.prep.sub": "Sauces, doughs or fillings you make once and use in several dishes.",
    "costs.prep.new": "+ New prep",
    "costs.prep.empty": "You don't have preps yet. Create the first one (e.g. tomato sauce).",
    "costs.prep.yields": "Yields",
    "costs.prep.unitU": "servings",
    "costs.prep.unitLt": "liters",
    "costs.prep.unitKg": "kilos",
    "costs.prep.perU": "per serving",
    "costs.prep.perLt": "per liter",
    "costs.prep.perKg": "per kilo",
    "costs.prep.editNew": "New prep",
    "costs.prep.editX": "Edit {name}",
    "costs.prep.editDesc": "Add what goes in it and how much it yields.",
    "costs.prep.name": "What's it called?",
    "costs.prep.namePh": "e.g. Tomato sauce",
    "costs.prep.yield": "How much does it yield?",
    "costs.prep.cost": "Costs {total} total → {perUnit} {per}.",
    "costs.prep.save": "Save prep",
    "costs.ajustes.eyebrow": "How we calculate",
    "costs.ajustes.title": "Settings",
    "costs.ajustes.sub": "Two numbers that define how we flag whether a dish is worth it.",
    "costs.ajustes.currency": "Your menu is in {menu} and costs in {costs}. Check that prices use the same currency.",
    "costs.ajustes.marginTitle": "How much profit do you want to keep?",
    "costs.ajustes.marginDesc": "If a dish leaves less than this, we flag it.",
    "costs.ajustes.marginLabel": "From each dish I want to keep at least",
    "costs.ajustes.marginHint": "A dish that leaves less than {n}% shows in yellow or red, with a price suggestion.",
    "costs.ajustes.indirectTitle": "Other costs (electricity, gas, wages)",
    "costs.ajustes.indirectDesc": "On top of ingredients, we add a bit to each dish for the venue's costs.",
    "costs.ajustes.indirectPre": "Add",
    "costs.ajustes.indirectPost": "for other costs",
    "costs.ajustes.indirectHint": "Example: on a dish with {a} of ingredients, we add {b}. If you don't want to add anything, set 0.",
    "costs.ajustes.save": "Save settings",
  },
  pt: {
    "costs.common.loading": "Carregando…",
    "costs.common.back": "Voltar",
    "costs.common.backAria": "Voltar",
    "costs.common.cancel": "Cancelar",
    "costs.common.save": "Salvar",
    "costs.common.saving": "Salvando…",
    "costs.common.saved": "✓ Salvo",
    "costs.common.unsaved": "Você tem alterações não salvas",
    "costs.nav.brand": "Custos e lucro",
    "costs.nav.backAria": "Voltar ao painel",
    "costs.nav.platos": "Meus pratos",
    "costs.nav.ingredientes": "Ingredientes",
    "costs.nav.ajustesAria": "Ajustes",
    "costs.status.ok": "Bom lucro",
    "costs.status.warn": "Lucro justo",
    "costs.status.bad": "Pouco lucro",
    "costs.status.loss": "Você está perdendo",
    "costs.status.unknown": "Sem custo",
    "costs.keep.pos": "você fica com {m}",
    "costs.keep.neg": "você perde {m}",
    "costs.line.costs": "custa",
    "costs.line.sells": "você vende a",
    "costs.line.sellsIt": "você vende a",
    "costs.confirm.discard": "Você tem alterações não salvas. Sair e descartá-las?",
    "costs.line.direct": "Ingredientes",
    "costs.line.indirect": "outros gastos ({n}%)",
    "costs.common.saveError": "Erro ao salvar",
    "costs.priceN": "Preço {n}",
    "costs.platos.eyebrow": "Seus números",
    "costs.platos.title": "Meus pratos",
    "costs.platos.sub": "Quanto cada prato custa e quanto sobra ao vendê-lo.",
    "costs.platos.avgLbl": "Em média, cada prato te deixa",
    "costs.platos.perDish": "por prato",
    "costs.platos.progress": "Você custeou {done} de {total} pratos. Cadastre os que faltam para ver o panorama completo.",
    "costs.platos.startLbl": "Vamos começar",
    "costs.platos.startBig": "Custeie seu primeiro prato",
    "costs.platos.startCap": "Escolha um prato da lista e cadastre o que leva. Em um minuto você saberá quanto ele te deixa.",
    "costs.platos.best": "O que mais te deixa",
    "costs.platos.watch": "Atenção com este",
    "costs.platos.grpRevisar": "Para revisar",
    "costs.platos.grpBien": "Vão bem",
    "costs.platos.grpSin": "Sem custear",
    "costs.platos.fix": "↑ Cobrando {price} você ficaria com {keep}",
    "costs.platos.noPrice": "Este prato não tem preço no cardápio — cadastre para ver quanto sobra",
    "costs.platos.todo": "Cadastre o que leva este prato para ver quanto você ganha",
    "costs.platos.costear": "Custear",
    "costs.costear.sellsAt": "você vende a {m}",
    "costs.recipe.title": "O que leva este prato?",
    "costs.recipe.desc": "Digite um ingrediente; se não existir, crie na hora.",
    "costs.costear.escapeQ": "Não sabe os detalhes?",
    "costs.costear.escapeLink": "Coloque um custo aproximado e pronto →",
    "costs.quick.title": "Custo aproximado",
    "costs.quick.desc": "Coloque mais ou menos quanto custa fazer este prato.",
    "costs.quick.label": "Me custa, mais ou menos…",
    "costs.quick.backQ": "Prefere cadastrar os ingredientes?",
    "costs.quick.backLink": "Detalhar a receita →",
    "costs.adv.title": "Ajustes avançados",
    "costs.adv.indirect": "Somamos {n}% a cada prato por outros gastos (luz, gás). Você muda em Ajustes.",
    "costs.adv.remove": "Remover o custo deste prato",
    "costs.panel.keep": "Com isto, você fica com",
    "costs.panel.lose": "Com isto, você perde",
    "costs.panel.noCost": "Ainda sem custo",
    "costs.panel.keepPct": "Você fica com {n}% de cada prato.",
    "costs.panel.ok": "Está ótimo 👍 Boa margem neste prato.",
    "costs.panel.suggest": "Para deixar {n}% de lucro, você deveria cobrar {price}.",
    "costs.panel.hint": "Cadastre o que leva o prato e você verá, ao vivo, quanto ele te deixa.",
    "costs.recipe.search": "Digite para buscar ou criar um ingrediente…",
    "costs.recipe.prepTag": "preparo",
    "costs.recipe.createPre": "Criar",
    "costs.recipe.createPost": "novo",
    "costs.recipe.prepOwn": "preparo próprio",
    "costs.recipe.empty": "Você ainda não cadastrou ingredientes. Busque o primeiro acima.",
    "costs.create.title": "Novo ingrediente",
    "costs.create.what": "O que você compra?",
    "costs.create.price": "Quanto custa?",
    "costs.create.how": "Como você compra?",
    "costs.create.add": "Adicionar ingrediente",
    "costs.buy.kg": "Por quilo",
    "costs.buy.u": "Por unidade",
    "costs.buy.lt": "Por litro",
    "costs.buy.doc": "Por dúzia",
    "costs.buyTr.gram": "Fica {m} o grama.",
    "costs.buyTr.ml": "Fica {m} o ml.",
    "costs.buyTr.each": "Fica {m} cada.",
    "costs.buyTr.zero": "Coloque o preço para calcular o custo.",
    "costs.per.kg": "o quilo",
    "costs.per.g": "o grama",
    "costs.per.lt": "o litro",
    "costs.per.ml": "o ml",
    "costs.per.doc": "a dúzia",
    "costs.per.u": "cada",
    "costs.ing.eyebrow": "O que você compra",
    "costs.ing.title": "Ingredientes",
    "costs.ing.sub": "Você cadastra o preço uma vez e serve para todos os pratos que o usam.",
    "costs.ing.addTitle": "Adicionar um ingrediente",
    "costs.ing.addDesc": "Comece a digitar e sugerimos os comuns.",
    "costs.ing.namePh": "Ex: Muçarela",
    "costs.ing.presetKg": "por quilo",
    "costs.ing.presetU": "por unidade",
    "costs.ing.presetLt": "por litro",
    "costs.ing.empty": "Você ainda não cadastrou ingredientes. Adicione o primeiro acima.",
    "costs.ing.unused": "Sem uso ainda",
    "costs.ing.usedIn": "Usado em",
    "costs.ing.and": "e",
    "costs.ing.platoSing": "prato",
    "costs.ing.platoPlur": "pratos",
    "costs.ing.prepSing": "preparo",
    "costs.ing.prepPlur": "preparos",
    "costs.ing.updated": "atualizado {ago}",
    "costs.ago.today": "hoje",
    "costs.ago.yesterday": "ontem",
    "costs.ago.days": "há {n} dias",
    "costs.ago.month": "há 1 mês",
    "costs.ago.months": "há {n} meses",
    "costs.confirm.remove": "Remover o custo de \"{name}\"? O prato continua no cardápio, só a ficha de custo é apagada.",
    "costs.confirm.delUsed": "\"{name}\" é usado em {n} {recetas} ({list}). Se apagar, é removido dessas receitas. Continuar?",
    "costs.confirm.recetaSing": "receita",
    "costs.confirm.recetaPlur": "receitas",
    "costs.confirm.del": "Excluir \"{name}\"?",
    "costs.confirm.delPrep": "\"{name}\" é usado em {n} {platos}. Se apagar, é removido dessas receitas. Continuar?",
    "costs.confirm.delPrepSimple": "Excluir o preparo \"{name}\"?",
    "costs.prep.eyebrow": "O que você prepara",
    "costs.prep.title": "Preparos",
    "costs.prep.sub": "Molhos, massas ou recheios que você faz uma vez e usa em vários pratos.",
    "costs.prep.new": "+ Novo preparo",
    "costs.prep.empty": "Você ainda não tem preparos. Crie o primeiro (ex: molho de tomate).",
    "costs.prep.yields": "Rende",
    "costs.prep.unitU": "porções",
    "costs.prep.unitLt": "litros",
    "costs.prep.unitKg": "quilos",
    "costs.prep.perU": "a porção",
    "costs.prep.perLt": "o litro",
    "costs.prep.perKg": "o quilo",
    "costs.prep.editNew": "Novo preparo",
    "costs.prep.editX": "Editar {name}",
    "costs.prep.editDesc": "Cadastre o que leva e quanto rende.",
    "costs.prep.name": "Como se chama?",
    "costs.prep.namePh": "Ex: Molho de tomate",
    "costs.prep.yield": "Quanto rende?",
    "costs.prep.cost": "Custa {total} no total → {perUnit} {per}.",
    "costs.prep.save": "Salvar preparo",
    "costs.ajustes.eyebrow": "Como calculamos",
    "costs.ajustes.title": "Ajustes",
    "costs.ajustes.sub": "Dois números que definem como avisamos se um prato vale a pena.",
    "costs.ajustes.currency": "Seu cardápio está em {menu} e os custos em {costs}. Verifique se os preços usam a mesma moeda.",
    "costs.ajustes.marginTitle": "Quanto lucro você quer deixar?",
    "costs.ajustes.marginDesc": "Se um prato deixa menos que isso, avisamos.",
    "costs.ajustes.marginLabel": "De cada prato quero ficar com pelo menos",
    "costs.ajustes.marginHint": "Um prato que deixa menos de {n}% aparece em amarelo ou vermelho, com sugestão de preço.",
    "costs.ajustes.indirectTitle": "Outros gastos (luz, gás, salários)",
    "costs.ajustes.indirectDesc": "Além dos ingredientes, somamos um pouco a cada prato pelos gastos do local.",
    "costs.ajustes.indirectPre": "Somar",
    "costs.ajustes.indirectPost": "por outros gastos",
    "costs.ajustes.indirectHint": "Exemplo: num prato com {a} de ingredientes, somamos {b}. Se não quiser somar nada, coloque 0.",
    "costs.ajustes.save": "Salvar ajustes",
  },
};

export default costs;
